import { DynamicStringSchema, DynamicNumberSchema, ActionSchema } from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { ApplyPayment } from './ApplyPayment';

interface ResolvedProps {
  readonly policyNumber: string;
  readonly billingType?: string;
  readonly totalPremium?: number;
  readonly commissions?: number;
  readonly invoiceAmount?: number;
  readonly alreadyPaid?: number;
  readonly amountDue?: number;
  readonly paymentTypes?: string;
  readonly processors?: string;
  readonly onCancel?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  policyNumber: DynamicStringSchema,
  billingType: DynamicStringSchema,
  totalPremium: DynamicNumberSchema,
  commissions: DynamicNumberSchema,
  invoiceAmount: DynamicNumberSchema,
  alreadyPaid: DynamicNumberSchema,
  amountDue: DynamicNumberSchema,
  paymentTypes: DynamicStringSchema,
  processors: DynamicStringSchema,
  onCancel: ActionSchema,
}) as any;

export const ApplyPaymentImpl = createComponentImplementation(
  { name: 'ApplyPayment', schema },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ props }: { props: ResolvedProps; buildChild: any; context: any }) => (
    <ApplyPayment
      policyNumber={props.policyNumber ?? ''}
      billingType={props.billingType}
      totalPremium={props.totalPremium}
      commissions={props.commissions}
      invoiceAmount={props.invoiceAmount}
      alreadyPaid={props.alreadyPaid}
      amountDue={props.amountDue}
      paymentTypes={props.paymentTypes}
      processors={props.processors}
      onCancel={props.onCancel}
    />
  )
);
